import PromoterPublish from './PromoterPublish';

export default PromoterPublish;
